import React from 'react';
import '../Style/ContactHeader.css';

const PrototypeHeader = () => {
  return (
    <div className="contact-header">
      <div className="overlay">
        <h1 className="contact-title">
          Prototyping and New Product Introduction (NPI)
        </h1>
        <p className="contact-subtitle">
          Fast, Flexible Prototyping – Turning Your Innovations Into Reality
        </p>
      </div>

      {/* Bottom Curve */}
      <svg className="header-curve" viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path
          d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z"
          fill="#ffffff"
        />
      </svg>
    </div>
  );
};

export default PrototypeHeader;